import React from "react";
import Pbp from 'components/general/Pbp'
import SportCode from "components/common/SportCode";
import { DefaultRenderCompetitor } from 'components/general/Pbp'
import { useViewport } from 'components/general/useViewPort';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const BscPbp = ({ data, periodsOrder }) => {
    const configPpb = {
        centerRender: BscRenderCenter,
        headerRender: BscHeaderRender,
        sideRender: BscRenderSide,
        layout: "points_left",
        periodsOrder: periodsOrder,
        reverseSorting: true
    }

    return (<>
        <Pbp data={data} config={configPpb} />
    </>);
}

const BscRenderSide = ({ action, homeAway }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const comp = action?.competitors?.find(item => item.pbpc_code === homeAway.participant?.code)

    if (!comp) return; //do nothing if there is no competitor related to the action

    return (
        <div className="box d-flex flex-row flex-wrap">
            <div><DefaultRenderCompetitor comp={comp} homeAway={homeAway} action={action} /></div>
            <div>
                <SportCode discipline={mirs_discipline} entity='@Action' code={action?.pbpa_Action} />&nbsp;
                <SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} />&nbsp;
            </div>
        </div>
    )
}

const BscHeaderRender = ({ home, away }) => {
    const { breakPoint } = useViewport();
    if (breakPoint === "sm" || breakPoint === "xs") {
        return ''
    }
    return (
        <div className="row">

        </div>
    )
}

const BscRenderCenter = ({ action }) => {
    let [a, b, c] = ['', '', ''];

    if (action.competitors === undefined) {
        a = <div><SportCode discipline='BSC' entity='@ActionComment' code={action.pbpa_Comment} /></div>
    }

    if (action?.pbpa_When !== 'PSO')
        b = <div>{action?.pbpa_When}</div>

    if (action.pbpa_Action === 'DSQ' || action.pbpa_Action === 'DQB' || action.pbpa_Action === 'WDR')
        b = <div>{action?.pbpa_Action}</div>

    if (action.pbpa_ScoreH) {
        c = <div><strong>{action?.pbpa_ScoreH} - {action?.pbpa_ScoreA}</strong></div>
    }
    return (<div className='box-center text-center'><strong>{a}{b}{c}</strong></div>);
}

export default BscPbp